import React from 'react';
import NavigationMenuSection from "../menu/menu-items/section/section";
import NavigationMenuItemUrl from "../menu/menu-items/menu-item-url";
import {GroupedData} from "../../core/data-structures/group";
import MenuSearch_NoResults from "./no-results";

type Props = {
    searchResult        : GroupedData
    noResultsMessage?   : string

}

export default function MenuSearch_SettingsResults(props: Props) {

    if(_.isEmpty(props.searchResult)){
        return <MenuSearch_NoResults message={props.noResultsMessage || "No results found"} />
    }

    return (
        <>
            {_.map(props.searchResult, (group) => (
                    <NavigationMenuSection
                        key         = {group.label}
                        name        = {group.label}
                        collapsible = {true}
                        isOpen      = {true}>

                        {_.map(group.items, (item, key) => (
                            <NavigationMenuItemUrl
                                key     = {key}
                                name    = {item.name}
                                icon    = {item.svgIcon + " fs-22"}
                                url     = {item.settingsUrl}
                            />
                        ))}

                    </NavigationMenuSection>
                ))
            }
        </>
    );
}
